<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6 mt-3 float-right">
                <b-button variant="primary" class="mb-2 float-right btn-custom" :to="'documents/create'"><font-awesome-icon icon="plus"/></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom"></div>
        <b-row>
            <b-col md="12">
                <b-row class="mt-3 mb-2">
                <b-col md="3 mb-2">
                  <b-form-input v-model="tableFilter.name" v-on:afterHit="doFilter" customQueryParamName="search" placeholder="Name"/>
                </b-col>
                <b-col md="3 mb-2">
                  <b-form-select v-model="tableFilter.category" :options="categoryList" />
                </b-col>
                <b-col md="3 mb-2">
                  <b-form-input v-model="tableFilter.search_customer" v-on:afterHit="doFilter" customQueryParamName="search" placeholder="Customer"/>
                </b-col>
                <b-col md="3 mb-2">
                  <date-picker v-model="tableFilter.date" type="date" range placeholder="Date Range"></date-picker>
                </b-col>
              </b-row>
            </b-col>
        </b-row>
        <table class="table table-hovered table-striped">
            <thead>
                <tr>
                    <th>No. Document</th>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Customer</th>
                    <!--<th>File Name</th>-->
                    <th>Created</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>DOC-001</td>
                    <td>02.06.2020 QRT DIGI MERU UTAMA.pdf</td>
                    <td>QRT</td>
                    <td>DIGI</td>
                    <!--<td><a href="#" style="color:#0000EE!important;text-decoration:underline!important;">digireport.pdf</a></td>-->
                    <td>2020-06-02</td>
                    <td>
                        <a v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#/documents/:uuid'"></a>
                    </td>
                </tr>
            </tbody>
        </table>
        <!--<paginated-table ref="dataTable" :can-delete="false" :can-show="true" :can-edit-modal="false" :can-edit="true" :can-reject="false" :can-approve="false" :data-url="apiUrl" :data-key="dataKey" :data-columns="columns">
        </paginated-table>-->
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    export default {
        name: 'category',
        components: {
            PaginatedTable,
            DatePicker
        },
        data () {
            return {
                dataKey: 'document',
                apiUrl: window.AppConfig.apiUrl + 'document',
                categoryList: [
                    {
                        value: null,
                        text: 'Category'
                    },
                    {
                        value: 'QRT',
                        text: 'QRT'
                    },
                    {
                        value: 'SIR',
                        text: 'SIR'
                    },
                    {
                        value: 'Live Report',
                        text: 'LIVE REPORT'
                    },
                    {
                        value: 'CM/PM/Hardening',
                        text: 'CM/PM/HARDENING'
                    },
                    {
                        value: 'Ticketing (Open Ticket)',
                        text: 'TICKETING (OPEN TICKET)'
                    },
                ],
                customerList: [
                    {
                        value: '',
                        text: 'Please Select Customer'
                    }
                ],
                tableFilter: {
                  name: this.$route.query.name,
                  search_customer: this.$route.query.search_customer,
                  category_uuid: this.$route.query.category,
                  category: null,
                  date: null,
                  start_date: this.$route.query.start_date,
                  end_date: this.$route.query.end_date
                }
            }
        },
        watch: {
          'tableFilter.name' () {
            this.doFilter()
          },
          'tableFilter.search_customer' () {
            this.doFilter()
          },
          'tableFilter.category' () {
            this.doFilter()
          },
          'tableFilter.date' (value) {
            if (value !== null && value.length >= 1 && value[0] === null && value[1] === null) {
              this.tableFilter.date = null
              this.doFilter()
            } else {
              this.doFilter()
            }
          }
        },
        mounted() {
            this.getCustomer()
        },
        methods: {
            doFilter () {
            this.tableFilter.name = this.tableFilter.name
            this.tableFilter.search_customer = this.tableFilter.search_customer
            this.tableFilter.category_uuid = this.tableFilter.category
            this.tableFilter.start_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') : null
            this.tableFilter.end_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD') : null
            this.$refs.dataTable.doFilter(this.tableFilter)
          },
          getCustomer () {
            this.$http.get(window.AppConfig.apiUrl + 'customer').then(response => {
              this.customerList = [
                  {
                      value: '',
                      text: 'Please Select Customer'
                  }
              ]
              response.data._embedded.customer.forEach(data => {
                this.customerList.push({
                  value: data.uuid,
                  text: data.name
                })
              })
            })
          },
        },
    }
</script>